import React from "react";

export default function FinanceDashboard() {
  return (
    <div>
      <h2>FinanceDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}